import scVue from "vue";
window.scVue = scVue;
import "document-register-element";
import VueCustomElement from "vue-custom-element";

import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";

import "clientjs";
window.scClient = new ClientJS();

window.sellCodesEmbedPurchase = {};

// const scBaseUrl = "https://dev.sellcodes.com";
// const scBaseUrl = "http://sellcodes.development";
const scBaseUrl = process.env.BASE_URL;
window.scAxios = require("axios");
window.scAxios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
// window.scAxios.defaults.withCredentials = true
window.scAxios.defaults.baseURL = scBaseUrl + "/";
window.scViewport = document.head.querySelector('meta[name="viewport"]') ?
    document.head.querySelector('meta[name="viewport"]').getAttribute("content") :
    "";

window.sellCodesPurchase = {
    /**
     * Config of purchase process
     */
    config: {
        /**
         * SellCodes host.
         */
        host: "https://sellcodes.com",

        /**
         *
         */
        apiKey: "",
    },
    /**
     * Handles purchase process
     */
    operations: {
        /**
         * Initialize license information object
         *
         * @param {object} licenseData {licenseKey, licenseEmail, productKey, optionKey}
         */
        init: function (licenseData) {
            this._licenseData = licenseData;
        },
        /**
         * Check if purchases are allowed for given buyer and seller and calls success or error callback
         *
         * @param {function} successCallback A function to invoke when the checking succeeds. It will receive information about amount and discount.
         * @param {function} errorCallback A function to invoke when the the checking fails. It will receive an error object {status, message}.
         */
        status: function (successCallback, errorCallback) {
            // Browser is not capable of making cross-origin Ajax calls
            if (!sellCodesPurchase.browser.corsSupport()) {
                errorCallback({
                    status: false,
                    message: "Browser does not support making cross-origin Ajax calls",
                });
                return;
            }
            let formData = new FormData();
            for (const item in this._licenseData) {
                if (Object.hasOwnProperty.call(this._licenseData, item)) {
                    formData.append(item, this._licenseData[item]);
                }
            }
            // Check if purchase is allowed for given License Key
            window.scAxios
                .post("/embed/selling/status", formData, {
                    // Send extra header for POST request
                    headers: {
                        "X-API-KEY": window.sellCodesPurchase.config.apiKey,
                        "Content-type": "application/x-www-form-urlencoded",
                    },
                })
                .then((result) => {
                    if (result === null || result.data === null) {
                        errorCallback({
                            xmlHttp: result.request,
                            status: false,
                            message: "Request processing error",
                        });
                        return;
                    }
                    successCallback(result.data);
                })
                .catch((result) => {
                    if (result) return errorCallback(result);

                    // In a browser its shown as 499,
                    // however the client computer blocks the call even before it's able to do the request
                    // (most likely due to an antivirus)
                    if (result.response.data.status == "0") {
                        errorCallback({
                            xmlHttp: result.request,
                            status: false,
                            message: "An HTTP request was blocked by the User's computer (probably due to an antivirus)",
                        });
                        return;
                    }

                    errorCallback(result.data);
                });
        },

        /**
         * Check if discount is valid for purchase and calls success or error callback
         *
         * @param {object} requestData Request details {discountCode}
         * @param {function} successCallback A function to invoke when the checking succeeds. It will receive information about new amount and new VAT.
         * @param {function} errorCallback A function to invoke when the the checking fails. It will receive an error object {status, message}.
         */
        discount: function (requestData, successCallback, errorCallback) {
            // Browser is not capable of making cross-origin Ajax calls
            if (!sellCodesPurchase.browser.corsSupport()) {
                errorCallback({
                    status: false,
                    message: "Browser does not support making cross-origin Ajax calls",
                });
                return;
            }

            requestData = Object.assign(this._licenseData, requestData);
            let formData = new FormData();
            for (const item in requestData) {
                if (Object.hasOwnProperty.call(requestData, item)) {
                    formData.append(item, requestData[item]);
                }
            }
            // Check if purchase is allowed for given License Key
            window.scAxios
                .post("/embed/selling/discount", formData, {
                    // Send extra header for POST request
                    headers: {
                        "X-API-KEY": window.sellCodesPurchase.config.apiKey,
                        "Content-type": "application/x-www-form-urlencoded",
                    },
                })
                .then((result) => {
                    if (result === null || result.data === null) {
                        errorCallback({
                            xmlHttp: result.request,
                            status: false,
                            message: "Request processing error",
                        });
                        return;
                    }
                    successCallback(result.data);
                })
                .catch((result) => {
                    if (result) return errorCallback(result);

                    // In a browser its shown as 499,
                    // however the client computer blocks the call even before it's able to do the request
                    // (most likely due to an antivirus)
                    if (result.response.data.status == "0") {
                        errorCallback({
                            xmlHttp: result.request,
                            status: false,
                            message: "An HTTP request was blocked by the User's computer (probably due to an antivirus)",
                        });
                        return;
                    }

                    errorCallback(result.data);
                });
        },
        /**
         * Execute purchase process and calls success or error callback
         *
         * @param {object} requestData Request details {discountCode}
         * @param {function} successCallback A function to invoke when the purchase succeeds. It will receive information about purchase.
         * @param {function} errorCallback A function to invoke when the the purchase fails. It will receive an error object {status, message}.
         */
        payment: function (requestData, successCallback, errorCallback) {
            // Browser is not capable of making cross-origin Ajax calls
            if (!sellCodesPurchase.browser.corsSupport()) {
                errorCallback({
                    status: false,
                    message: "Browser does not support making cross-origin Ajax calls",
                });
                return;
            }

            // open popup window
            sellCodesPurchase._popups._open(errorCallback);

            requestData = Object.assign(this._licenseData, requestData);
            let formData = new FormData();
            for (const item in requestData) {
                if (Object.hasOwnProperty.call(requestData, item)) {
                    formData.append(item, requestData[item]);
                }
            }
            // Check if purchase is allowed for given License Key
            window.scAxios
                .post("/embed/selling/payment", formData, {
                    // Send extra header for POST request
                    headers: {
                        "X-API-KEY": window.sellCodesPurchase.config.apiKey,
                        "Content-type": "application/x-www-form-urlencoded",
                    },
                })
                .then((result) => {
                    if (result === null || result.data === null) {
                        errorCallback({
                            xmlHttp: result.request,
                            status: false,
                            message: "Request processing error",
                        });
                        return;
                    }
                    if (
                        typeof result.data.data === "object" &&
                        typeof result.data.data.redirect_url === "string"
                    ) {
                        sellCodesPurchase._popups._addListener(
                            successCallback,
                            errorCallback
                        );
                        sellCodesPurchase._popupInstance.location =
                            result.data.data.redirect_url;
                    } else {
                        sellCodesPurchase._popups._close();
                        // Send result to success callback
                        successCallback(result.data);
                    }
                })
                .catch((result) => {
                    sellCodesPurchase._popups._close();

                    if (result) return errorCallback(result);

                    // In a browser its shown as 499,
                    // however the client computer blocks the call even before it's able to do the request
                    // (most likely due to an antivirus)
                    if (result.response.data.status == "0") {
                        errorCallback({
                            xmlHttp: result.request,
                            status: false,
                            message: "An HTTP request was blocked by the User's computer (probably due to an antivirus)",
                        });
                        return;
                    }

                    errorCallback(result.data);
                });
        },
    },

    /**
     * Work with popups
     *
     * @private
     */
    _popups: {
        /**
         * Create an popup window.
         *
         * @param {string} url
         *
         * @private
         */
        _make: function (url) {
            var name = "sellCodesProcessPurchase";

            var dualScreenWidth =
                window.innerWidth ||
                document.documentElement.clientWidth ||
                window.screen.width;
            var dualScreenHeight =
                window.innerHeight ||
                document.documentElement.clientHeight ||
                window.screen.height;
            var dualScreenLeft = window.screenLeft || window.screen.left;
            var dualScreenTop = window.screenTop || window.screen.top;

            var specs = {
                width: 600,
                height: 720,
                toolbar: 0,
                menubar: 0,
                location: 0,
                status: 1,
                scrollbars: 1,
                resizable: 1,
            };

            specs.left = dualScreenWidth / 2 - specs.width / 2 + dualScreenLeft;
            specs.top = dualScreenHeight / 2 - specs.height / 2 + dualScreenTop;

            // Open new window
            sellCodesPurchase._popupInstance = window.open(
                url,
                name,
                sellCodesPurchase.helpers.joinObjKeyVal(specs)
            );
        },

        /**
         *
         * @param {function} successCallback
         * @param {function} errorCallback
         *
         * @private
         */
        _addListener: function (successCallback, errorCallback) {
            sellCodesPurchase._popupListener = function (e) {
                sellCodesPurchase._popups._makeListener(
                    e,
                    successCallback,
                    errorCallback
                );
            };

            window.addEventListener("message", sellCodesPurchase._popupListener);
        },

        /**
         *
         * @param {object} e
         * @param {function} successCallback
         * @param {function} errorCallback
         *
         * @private
         */
        _makeListener: function (e, successCallback, errorCallback) {
            if (
                typeof e.data === "string" &&
                e.origin === sellCodesPurchase.config.host
            ) {
                let data = JSON.parse(e.data);

                if (
                    typeof data.type === "string" &&
                    data.type.toUpperCase() === "SELLCODES_PURCHASE_MESSAGE"
                ) {
                    clearInterval(sellCodesPurchase._popUpTimer);

                    window.removeEventListener(
                        "message",
                        sellCodesPurchase._popupListener
                    );

                    if (typeof data.response !== "object") {
                        errorCallback({
                            status: false,
                            message: "Request processing error",
                        });
                    } else {
                        if (data.response.status === true) {
                            successCallback(data.response);
                        } else {
                            errorCallback(data.response);
                        }
                    }
                }
            }
        },

        /**
         *
         * @param {function} errorCallback
         * @private
         */
        _open: function (errorCallback) {
            sellCodesPurchase._popups._make(
                sellCodesPurchase.config.host + "/quick-purchase/processing"
            );

            // uses for catch close of popUp window
            sellCodesPurchase._popUpTimer = setInterval(function () {
                if (sellCodesPurchase._popupInstance.closed) {
                    clearInterval(sellCodesPurchase._popUpTimer);

                    errorCallback({
                        status: false,
                    });
                }
            }, 200);
        },

        /**
         *
         * @private
         */
        _close: function () {
            if (sellCodesPurchase._popupInstance) {
                setTimeout(function () {
                    clearInterval(sellCodesPurchase._popUpTimer);
                    sellCodesPurchase._popupInstance.close();
                }, 350);
            }
        },
    },
    /**
     * Helper methods
     */
    helpers: {
        /**
         * Join object's keys and values into string.
         *
         * @param {object} obj
         * @param {string} delimiter
         * @param {string} separator
         *
         * @returns {string}
         */
        joinObjKeyVal: function (obj, delimiter, separator) {
            delimiter = delimiter || "=";
            separator = separator || ",";

            return Object.keys(obj)
                .reduce(function (acc, key) {
                    acc.push(key + delimiter + obj[key]);
                    return acc;
                }, [])
                .join(separator);
        },
    },
    /**
     * Browser support querying
     */
    browser: {
        /**
         * Returns true if browser is capable of making cross-origin Ajax calls
         */
        corsSupport: function () {
            // Test if runtime is React Native
            return window.navigator.product === "ReactNative" ?
                true : // IE 10 and above, Firefox, Chrome, Opera etc.
                "withCredentials" in new XMLHttpRequest() ?
                    true : // IE 8 and IE 9
                    !!window.XDomainRequest;
        },
    },
};

Date.prototype.scFormat = function () {
    var mm = this.getMonth() + 1; // getMonth() is zero-based
    var dd = this.getDate();

    return [
        (dd > 9 ? "" : "0") + dd,
        (mm > 9 ? "" : "0") + mm,
        this.getFullYear(),
    ].join("/");
};

Date.prototype.scFormatShort = function () {
    var mm = this.getMonth() + 1; // getMonth() is zero-based
    var dd = this.getDate();

    return [
        (dd > 9 ? "" : "0") + dd,
        (mm > 9 ? "" : "0") + mm,
        this.getFullYear().toString().substr(-2),
    ].join("/");
};

scVue.use(VueCustomElement);

scVue.filter("TitleString", function (value) {
    if (value) {
        var string = value.replace(/([a-z])([A-Z])/g, "$1 $2").replace("_", " ");
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
});

scVue.filter("UpperString", function (value) {
    if (value) {
        return value.toUpperCase();
    }
});

scVue.filter("formatPrice", function (value) {
    if (isNaN(value)) {
        return "";
    }
    return `$` + value;
});

scVue.filter("cleanHTML", function (text) {
    return text.replaceAll("&amp;amp;", "&amp;");
});

window.externalLoadedScripts = [];

scVue.mixin({
    data() {
        return {
            scBaseUrl: scBaseUrl,
            scLoadedScripts: [],
            scLoadingScripts: [],
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth,
        };
    },
    computed: {
        corsSupport() {
            /**
             * Returns true if browser is capable of making cross-origin Ajax calls
             */
            // Test if runtime is React Native
            return window.navigator.product === "ReactNative"
                ? true
                : // IE 10 and above, Firefox, Chrome, Opera etc.
                "withCredentials" in new XMLHttpRequest()
                    ? true
                    : // IE 8 and IE 9
                    !!window.XDomainRequest;
        },
        mobileCheck() {
            let check = false;
            (function (a) {
                if (
                    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                        a
                    ) ||
                    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                        a.substr(0, 4)
                    )
                )
                    check = true;
            })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        },
        tipALign() {
            if (window.innerWidth < 665 || this.mobileCheck) {
                return "bottom-right";
            }
            return "bottom-left";
        },
        highestZIndex() {
            var elems = document.getElementsByTagName("div");
            var highest = 0;
            for (var i = 0; i < elems.length; i++) {
                var zindex = document.defaultView
                    .getComputedStyle(elems[i], null)
                    .getPropertyValue("z-index");
                if (zindex > highest && zindex != "auto") {
                    highest = zindex;
                }
            }
            return ++highest;
        },
        isSelfHosted() {
            let url = new URL(scBaseUrl);
            // console.log(url.host, window.location.hostname, this.inIframe);
            return (
                window.location.hostname.includes(url.host) ||
                window.location.hostname.includes("sellcodes.development")
            );
        },
        inIframe() {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        },
    },
    async mounted() {
        await this.loadScript(
            "mangoPay",
            this.scBaseUrl + "/quick-checkout/libs/mangopay-kit.min.js"
        );
        // this.loadScript(
        //   "fondy",
        //   "https://unpkg.com/ipsp-js-sdk@latest/dist/checkout.min.js"
        // );
        // this.loadScript(
        //     "stripe",
        //     "https://js.stripe.com/v3/"
        // );
        // await this.loadScript(
        //     "paddle",
        //     "https://cdn.paddle.com/paddle/paddle.js"
        // );
        this.$nextTick(() => {
            this.windowHeight = window.innerHeight;
            this.windowWidth = window.innerWidth;
        });
    },
    methods: {
        getVideoCardInfo() {
            const gl = document.createElement("canvas").getContext("webgl");
            if (!gl) {
                return "No GPU Info";
            }
            const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
            return debugInfo
                ? `${gl.getParameter(
                    debugInfo.UNMASKED_VENDOR_WEBGL
                )} ${gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)}`
                : "No GPU Info";
        },
        getDeviceName() {
            let device = "Unknown";
            const ua = {
                "Generic Linux": /Linux/i,
                Android: /Android/i,
                BlackBerry: /BlackBerry/i,
                Bluebird: /EF500/i,
                "Chrome OS": /CrOS/i,
                Datalogic: /DL-AXIS/i,
                Honeywell: /CT50/i,
                iPad: /iPad/i,
                iPhone: /iPhone/i,
                iPod: /iPod/i,
                macOS: /Macintosh/i,
                Windows: /IEMobile|Windows/i,
                Zebra: /TC70|TC55/i,
            };
            Object.keys(ua).map(
                (v) => navigator.userAgent.match(ua[v]) && (device = v)
            );
            return device;
        },
        decorateUrlWithGa(urlString) {
            if (this.hostname === "www.ultimatelysocial.com") {
                var ga = window[window["GoogleAnalyticsObject"]];
                var tracker;
                if (ga && typeof ga.getAll === "function") {
                    tracker = ga.getAll()[0]; // Uses the first tracker created on the page, but you could make it more robust by looking for the correct tracking ID or something
                    urlString = new window.gaplugins.Linker(tracker).decorate(urlString);
                }
            }
            return urlString;
        },
        validateEmail(email) {
            const re =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        isValidUrl(url) {
            var pattern = new RegExp(
                "^(https?:\\/\\/)?" + // protocol
                "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
                "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
                "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
                "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
                "(\\#[-a-z\\d_]*)?$",
                "i"
            ); // fragment locator
            return !!pattern.test(url);
        },
        detectValidCardType(number) {
            number = number
                .replace(/\D/g, "")
                .replace(/\s+/g, "")
                .replace(/[^0-9]/gi, "");
            var re = {
                electron: /^(4026|417500|4405|4508|4844|4913|4917)\d+$/,
                maestro:
                    /^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)\d+$/,
                visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
                mastercard: /^5[1-5][0-9]{14}$/,
            };

            for (var key in re) {
                if (re[key].test(number)) {
                    return true;
                }
            }
            return false;
        },
        isValidCompanyNumber(value) {
            // Define a regular expression to match only alphanumeric characters
            var regex = /^[a-zA-Z0-9]+$/;

            // Test the field against the regular expression
            return regex.test(value);
        },
        dateFormatter(date) {
            return new Date(date).scFormat();
        },
        observeDomChange() {
            // Select the node that will be observed for mutations
            const targetNode = document.getElementsByTagName("body")[0];

            // Options for the observer (which mutations to observe)
            const config = { attributes: true, childList: true, subtree: true };

            // Create an observer instance linked to the callback function
            const observer = new MutationObserver((mutationsList, observer) => {
                // Use traditional 'for loops' for IE 11
                for (const mutation of mutationsList) {
                    if (mutation.type === "childList") {
                        if (document.getElementsByClassName("ipsp-modal-wrapper").length) {
                            this.secure_status = true;
                        }
                    }
                }
            });

            // Start observing the target node for configured mutations
            observer.observe(targetNode, config);

            // Later, you can stop observing
            // observer.disconnect();
        },
        async loadScript(title, url) {
            if (this.isScriptLoaded(title)) {
                return false;
            }

            this.scLoadingScripts.push(title);

            const script = document.createElement("script");
            script.type = "text/javascript";
            script.id = title;

            await new Promise((resolve, reject) => {
                script.onload = resolve;
                script.onerror = reject;
                script.src = url;
                document.head.appendChild(script);
            });

            this.scLoadedScripts.push(title);
            externalLoadedScripts.push(title);

            const scLoadingScriptsIndex = this.scLoadingScripts.indexOf(title);
            if (scLoadingScriptsIndex > -1) {
                this.scLoadingScripts.splice(scLoadingScriptsIndex, 1);
            }
        },

        isScriptLoaded(title) {
            return (
                document.head.querySelector('script[id="' + title + '"]') !== null ||
                this.scLoadedScripts.includes(title) ||
                this.scLoadingScripts.includes(title)
            );
        }


    },
});

let handleOutsideClick;

scVue.directive("closable", {
    bind(el, binding, vnode) {
        // Here's the click/touchstart handler
        // (it is registered below)
        handleOutsideClick = (e) => {
            e.stopPropagation();
            // Get the handler method name and the exclude array
            // from the object used in v-closable
            const { handler, exclude } = binding.value;

            // This variable indicates if the clicked element is excluded
            let clickedOnExcludedEl = false;
            exclude.forEach((refName) => {
                // We only run this code if we haven't detected
                // any excluded element yet
                if (!clickedOnExcludedEl) {
                    // Get the element using the reference name
                    const excludedEl = vnode.context.$refs[refName];
                    // See if this excluded element
                    // is the same element the user just clicked on
                    clickedOnExcludedEl = excludedEl && excludedEl.contains(e.target);
                }
            });

            // We check to see if the clicked element is not
            // the dialog element and not excluded
            if (!el.contains(e.target) && !clickedOnExcludedEl) {
                // If the clicked element is outside the dialog
                // and not the button, then call the outside-click handler
                // from the same component this directive is used in
                vnode.context[handler]();
            }
        };
        // Register click/touchstart event listeners on the whole page
        document.addEventListener("click", handleOutsideClick);
        document.addEventListener("touchstart", handleOutsideClick);
    },

    unbind() {
        // If the element that has v-closable is removed, then
        // unbind click/touchstart listeners from the whole page
        document.removeEventListener("click", handleOutsideClick);
        document.removeEventListener("touchstart", handleOutsideClick);
    },
});

const requireComponent = require.context(
    "./components/common",
    // Whether or not to look in subfolders
    false,
    // The regular expression used to match base component filenames
    /Base[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach((fileName) => {
    // Get component config
    const componentConfig = requireComponent(fileName);

    // Get PascalCase name of component
    const componentName = upperFirst(
        camelCase(
            // Gets the file name regardless of folder depth
            fileName
                .split("/")
                .pop()
                .replace(/\.\w+$/, "")
        )
    );
    // Register component globally
    scVue.component(componentName, componentConfig.default || componentConfig);
});

// import and register your component(s)
import CheckoutButtonsComponent from "./components/CheckoutButtonsComponent";
scVue.customElement("sellcodes-checkout", CheckoutButtonsComponent);


// WEBPACK FOOTER //
// ./src/main.js